import template from './editContractInfoModal.html';
import controller from './editContractInfoModal.controller';

let editContractInfoModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
editContractInfoModalComponent.template = template;
editContractInfoModalComponent.controller = controller;

export default editContractInfoModalComponent;




// WEBPACK FOOTER //
// ./client/common/modals/editContractInfoModal/editContractInfoModal.component.js